import moment from 'moment';

export const getFormattedEvent = (event) => {
  if (!event) return null;

  return {
    delivered: {
      text: 'Enviado',
      color: '#0071c0'
    },
    sent: {
      text: 'Enviado',
      color: '#0071c0'
    },
    opened: {
      text: 'Aberto',
      color: '#03b14e'
    },
    clicked: {
      text: 'Clicado',
      color: '#03b14e'
    },
    complained: {
      text: 'Marcado como spam',
      color: '#ffc069'
    },
    failed: {
      text: 'Falhou',
      color: '#ff4d4f'
    },
    unsubscribed: {
      text: 'Inscrição cancelada',
      color: '#141414'
    },
    pendent: {
      text: 'Envio solicitado',
      color: '#9254de'
    },
    draft: {
      text: 'Rascunho',
      color: '#d3d3d3'
    },
    blacklist: {
      text: 'Blacklist',
      color: '#000000'
    },
    duplicated: {
      text: 'Duplicado',
      color: '#fa8c16'
    }
  }[event]
}

export const getDefaultDocumentsFilters = () => {
  const currentMonth = moment().format('YYYY-MM');
  return {
    filterBy: 'created_at',
    from: currentMonth,
    to: currentMonth,
    status: 'all',
    search: '',
  };
};

// Turns the saved month range ('YYYY-MM') into the /documents query params.
export const getDocumentsPeriodRequest = ({ filterBy, from, to }) => ({
  filterBy,
  from: moment(from, 'YYYY-MM').startOf('month').format('YYYY-MM-DD'),
  to: moment(to, 'YYYY-MM').endOf('month').format('YYYY-MM-DD'),
  min: 0,
  max: 0,
});

export const isPeriodTooLong = (from, to) =>
  moment(to, 'YYYY-MM').diff(moment(from, 'YYYY-MM'), 'months') > 12;

// Clique na linha abre a gaveta, menos quando foi num botão, link, tag
// clicável ou controle da própria linha (esses mantêm a ação que já têm).
const INTERACTIVE_SELECTOR = 'a, button, input, label, select, textarea, [role="button"], .ant-tag, .ant-checkbox-wrapper, .ant-switch, .ant-select, .ant-dropdown-trigger, .ant-popover-open';

export const isInteractiveClick = (target) => {
  let node = target;
  while (node && node.nodeType === 1) {
    if (node.tagName === 'TR' || node.tagName === 'TD') return false;
    if (typeof node.matches === 'function' && node.matches(INTERACTIVE_SELECTOR)) return true;
    node = node.parentNode;
  }
  return false;
};
